import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import VerifyEmailBanner from './VerifyEmailBanner';

const NAV = [
  {
    items: [
      { to: '/dashboard', label: 'Dashboard',    icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
      { to: '/roles',     label: 'Browse roles',  icon: 'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253' },
      { to: '/jd-prep',   label: 'JD Prep',       icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
      { to: '/courses',   label: 'Study Guides',  icon: 'M12 14l9-5-9-5-9 5 9 5z M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z' },
      { to: '/blog',      label: 'Blog',          icon: 'M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z' },
      { to: '/certificates', label: 'Certificates', icon: 'M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z' },
      { to: '/wallet',       label: 'Wallet',       icon: 'M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z' },
      { to: '/refer',        label: 'Refer & Earn', icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z' },
    ],
  },
];

const BOTTOM_NAV = [
  { to: '/settings', label: 'Settings', icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z M15 12a3 3 0 11-6 0 3 3 0 016 0z' },
];

function NavIcon({ d, size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
      {d.split(' M').map((segment, i) => (
        <path key={i} d={i === 0 ? segment : 'M' + segment} />
      ))}
    </svg>
  );
}

function SidebarNav({ open }) {
  return (
    <nav style={{ flex: 1, overflowY: 'auto', padding: '8px 0', scrollbarWidth: 'none' }}>
      {NAV.map(({ items }, gi) => (
        <div key={gi}>
          {items.map(({ to, icon, label }) => (
            <NavLink key={to} to={to} end={to === '/dashboard'}
              aria-label={label}
              title={!open ? label : undefined}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 11,
                padding: open ? '9px 14px' : '9px 0',
                justifyContent: open ? 'flex-start' : 'center',
                margin: '1px 8px', borderRadius: 8,
                textDecoration: 'none', fontSize: 14, fontWeight: isActive ? 600 : 400,
                color: isActive ? '#fff' : 'rgba(255,255,255,0.78)',
                background: isActive ? 'rgba(255,255,255,0.11)' : 'transparent',
                borderLeft: isActive ? '3px solid #C1272D' : '3px solid transparent',
                transition: 'background 0.12s, color 0.12s',
                overflow: 'hidden', whiteSpace: 'nowrap',
              })}>
              <NavIcon d={icon} />
              {open && <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{label}</span>}
            </NavLink>
          ))}
        </div>
      ))}
    </nav>
  );
}

function SidebarBottom({ open, user, onLogout }) {
  return (
    <div style={{ flexShrink: 0, borderTop: '1px solid rgba(255,255,255,0.07)' }}>
      {BOTTOM_NAV.map(({ to, icon, label }) => (
        <NavLink key={to} to={to}
          style={({ isActive }) => ({
            display: 'flex', alignItems: 'center', gap: 11,
            padding: open ? '9px 14px' : '9px 0',
            justifyContent: open ? 'flex-start' : 'center',
            margin: '4px 8px', borderRadius: 8,
            textDecoration: 'none', fontSize: 14, fontWeight: isActive ? 600 : 400,
            color: isActive ? '#fff' : 'rgba(255,255,255,0.78)',
            background: isActive ? 'rgba(255,255,255,0.11)' : 'transparent',
            borderLeft: isActive ? '3px solid #C1272D' : '3px solid transparent',
            transition: 'background 0.12s',
          })}>
          <NavIcon d={icon} />
          {open && <span>{label}</span>}
        </NavLink>
      ))}

      <div style={{
        display: 'flex', alignItems: 'center', gap: 10,
        padding: open ? '10px 14px 14px' : '10px 0 14px',
        justifyContent: open ? 'flex-start' : 'center',
      }}>
        <div style={{
          width: 32, height: 32, borderRadius: '50%', background: '#C1272D',
          color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontWeight: 700, fontSize: 13, flexShrink: 0, cursor: 'default',
          letterSpacing: '0.5px',
        }}>
          {(user?.full_name || user?.email || '?').split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase() || '?'}
        </div>
        {open && (
          <>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ margin: 0, color: '#fff', fontWeight: 600, fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {user?.full_name}
              </p>
              <p style={{ margin: 0, color: 'rgba(255,255,255,0.58)', fontSize: 11, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {user?.email}
              </p>
            </div>
            <button onClick={onLogout} title="Log out"
              aria-label="Log out"
              style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.58)', cursor: 'pointer', padding: 4, borderRadius: 6, display: 'flex', flexShrink: 0, transition: 'color 0.12s' }}
              onMouseEnter={e => e.currentTarget.style.color = '#fff'}
              onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.35)'}
            >
              <svg width={16} height={16} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />
              </svg>
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default function UserLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  const sidebarStyle = {
    width: open ? 240 : 60,
    background: '#0F172A',
    display: 'flex', flexDirection: 'column',
    flexShrink: 0, transition: 'width 0.18s ease',
    overflow: 'hidden', position: 'sticky', top: 0, height: '100vh',
  };

  const logoRow = (
    <div style={{
      display: 'flex', alignItems: 'center',
      justifyContent: open ? 'space-between' : 'center',
      height: 56, padding: open ? '0 14px 0 18px' : '0',
      flexShrink: 0, borderBottom: '1px solid rgba(255,255,255,0.07)',
    }}>
      {open && (
        <span style={{ color: '#fff', fontWeight: 700, fontSize: 16, letterSpacing: '-0.3px', whiteSpace: 'nowrap' }}>
          Centric<span style={{ color: '#C1272D' }}>Q</span>
        </span>
      )}
      <button onClick={() => setOpen(o => !o)} aria-label="Toggle sidebar"
        style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.52)', cursor: 'pointer', padding: 5, borderRadius: 6, display: 'flex', transition: 'color 0.12s' }}
        onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.7)'}
        onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.3)'}
      >
        <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
          {open
            ? <><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 3v18M15 9l-3 3 3 3"/></>
            : <><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 3v18M9 9l3 3-3 3"/></>
          }
        </svg>
      </button>
    </div>
  );

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
        .ul-sidebar   { display: flex !important; }
        .ul-mob-bar   { display: none  !important; }
        .ul-mob-ov    { display: none  !important; }
        @media (max-width: 768px) {
          .ul-sidebar { display: none  !important; }
          .ul-mob-bar { display: flex  !important; }
          .ul-mob-ov  { display: flex  !important; }
          .ul-main    { padding-top: 52px !important; }
        }
        nav a:hover { background: rgba(255,255,255,0.09) !important; color: #fff !important; }
        .skip-link { position:absolute; left:-9999px; top:auto; width:1px; height:1px; overflow:hidden; }
        .skip-link:focus { position:fixed; left:16px; top:16px; width:auto; height:auto; padding:10px 18px;
          background:#1B3A5C; color:#fff; font-weight:700; font-size:14px; border-radius:8px; z-index:9999;
          text-decoration:none; outline:2px solid #C1272D; }
      `}</style>
      <a href="#main-content" className="skip-link">Skip to main content</a>

      {/* Desktop sidebar */}
      <aside className="ul-sidebar" style={sidebarStyle}>
        {logoRow}
        <SidebarNav open={open} />
        <SidebarBottom open={open} user={user} onLogout={handleLogout}  />
      </aside>

      {/* Mobile top bar */}
      <div className="ul-mob-bar" style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: 52,
        background: '#0F172A', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 16px', zIndex: 50, borderBottom: '1px solid rgba(255,255,255,0.07)',
      }}>
        <span style={{ color: '#fff', fontWeight: 700, fontSize: 16 }}>
          Centric<span style={{ color: '#C1272D' }}>Q</span>
        </span>
        <button onClick={() => setMobileOpen(o => !o)} aria-label="Toggle menu"
          style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', padding: 4, display: 'flex' }}>
          <svg width={22} height={22} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
            {mobileOpen
              ? <><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></>
              : <><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></>
            }
          </svg>
        </button>
      </div>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div className="ul-mob-ov" style={{ position: 'fixed', inset: 0, zIndex: 40, background: 'rgba(0,0,0,0.5)' }}
          onClick={() => setMobileOpen(false)}>
          <aside style={{ width: 240, background: '#0F172A', height: '100%', display: 'flex', flexDirection: 'column' }}
            onClick={e => e.stopPropagation()}>
            {logoRow}
            <SidebarNav open={true} />
            <SidebarBottom open={true} user={user} onLogout={handleLogout}  />
          </aside>
        </div>
      )}

      {/* Main content */}
      <main id="main-content" className="ul-main" style={{ flex: 1, background: 'var(--bg, #F8FAFC)', overflowY: 'auto', minWidth: 0 }}>
        <VerifyEmailBanner />
        {children}
      </main>
    </div>
  );
}
